import { World } from '$legacyecstatic';
import { Components } from 'editor/components';

export interface IEvents {
  onEventsAdd(world: World<Components>): void;

  onEventsRemove(world: World<Components>): void;
}

class Events<T extends IEvents> {
  events: T;

  added = false;

  constructor(events: T) {
    this.events = events;
  }

  onEventsAdd(world: World<Components>): void {
    this.events.onEventsAdd(world);

    this.added = true;
  }

  onEventsRemove(world: World<Components>): void {
    // going to assume that if these events are removed then the component (or the entity that owns it) is destroyed.
    this.events.onEventsRemove(world);
  }
}

export default Events;
